import axios from "axios";
import { generateCorrelationId } from "./correlationId";
import { decryptedData, getConfigFromStroage } from "./getUrlsFromAws";
const { getApiData, createEcsApisArr } = require("../api/api");
const {
    getHeader,
    getCredentials,
    getUploadHeader,
    // generateCorrelationId
} = require("../api/headers");

export default class AxiosRequest {
    constructor(server = false) {
        this.__createClient(server);
    }

    // __fetchToken = async () => {
    //     try {
    //         const { url, body } = getApiData("authenticate");
    //         const res = await fetch(url, {
    //             method: "POST",
    //             headers: {
    //                 correlationId: generateCorrelationId(),
    //                 "Content-Type": "application/json",
    //             },
    //             body: JSON.stringify(body),
    //         });
    //         const json = await res.json();
    //         return json;
    //     } catch (err) {
    //         throw new Error(err.message);
    //     }
    // };

    __createClient = () => {
        var server = true;
        if (typeof document === "undefined") {
            server = false;
        }
        this.axiosClient = axios.create();
        this.axiosClient.interceptors.request.use(async (config) => {
            let newConfig = Object.assign({}, config);
            const urlsData = getConfigFromStroage();
            const EcsUrlsArr = createEcsApisArr()
            const useEcsApi = urlsData["useEcsApi"];
            const acstkn = sessionStorage.getItem("acstkn")
            const tokenValidity = sessionStorage.getItem("acstknv");
            const currentTime = new Date().getTime();
            let useEcsApiEnabled;
            if (useEcsApi) {
                useEcsApiEnabled = decryptedData(useEcsApi) === "Y" && EcsUrlsArr.includes(newConfig.url)
            }
            if (useEcsApiEnabled && (!acstkn || currentTime > parseInt(tokenValidity))) {
                await getAuthToken()
            }

            newConfig.data.request.header.correlationId = generateCorrelationId();
            if(useEcsApiEnabled) {
                newConfig.headers.common["Authorization"] = sessionStorage.getItem("acstkn")
            }
            newConfig.headers.common["x-api-key"] = getHeader()
            const posvRefNumber = newConfig.data.request.payload.posvRefNumber;
            if (!posvRefNumber) {
                newConfig.data.request.payload.posvRefNumber = localStorage.getItem(
                    "posvRefNumber"
                );
                newConfig.data.request.payload.planCode = localStorage.getItem("planCode");
            }
            console.log({ newConfig, EcsUrlsArr })
            return newConfig;
        });
    };

    getClient = () => {
        return this.axiosClient;
    };

    getCancelTokenSource = () => {
        return axios.default.CancelToken.source();
    };
}


export const getAuthToken = () => {
    const { url, body } = getApiData("getToken");
    const { clientId, clientSecret } = getCredentials();
    body.request.header.correlationId = generateCorrelationId();
    body.request.payload.clientId = clientId;
    body.request.payload.clientSecret = clientSecret;
    let xApiKey = getUploadHeader();
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(url, body, {
                headers: {
                    "x-api-key": xApiKey,
                },
            });
            console.log("GET TOKEN Response from axios.js : ", response);
            if (response?.data?.response?.payload?.accessToken) {
                sessionStorage.setItem('acstkn', response?.data?.response?.payload?.accessToken)
                const expiresIn = response?.data?.response?.payload?.expiresIn;
                const tokenValidity = new Date().getTime() + expiresIn * 1000;
                sessionStorage.setItem('acstknv', tokenValidity);
                resolve({ acstkn: response?.data?.response?.payload?.accessToken })
            } else {
                throw { msg: "Error in generating token" }
            }
        } catch (err) {
            console.log("GET TOKEN ERR", err);
            reject({ err })
        }
    })

};